import React, { useState } from 'react';
import { Box } from '@mui/material';
import { STUDENT_TEST_BAR } from '../../../../utils/constants';
import CustomizeTabs from '../../../../components/CustomizeTabs';
import UpcomingTestList from '../Test/Student.UpcomingTestList';
import PreviousTestList from '../Test/Student.PreviousTestList';

export default function StudentTests() {
  const [value, setValue] = useState(0);
  const [examSelected, setExamSelected] = useState(false);
  const handleChange = (newValue) => {
    setValue(newValue);
  };

  return (
    <div style={{ marginTop: 15 }}>
      {!examSelected && (
        <CustomizeTabs options={STUDENT_TEST_BAR} value={value} onChange={(v) => handleChange(v)} />
      )}
      <Box mt={2}>
        {value === 0 && <UpcomingTestList handleExamSelected={(v) => setExamSelected(v)} />}
        {value === 1 && <PreviousTestList handleExamSelected={(v) => setExamSelected(v)} />}
      </Box>
    </div>
  );
}
